"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Label_1 = require("components/Label");
var Select_1 = require("components/Select");
var findErrors_1 = require("lib/functions/findErrors");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var validations_1 = require("lib/functions/validations");
var rules = {
    citizenship: validations_1.mandatory,
    gender: validations_1.mandatory
};
var CitizenshipGenderInfoForm = (function (_super) {
    __extends(CitizenshipGenderInfoForm, _super);
    function CitizenshipGenderInfoForm(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Object.defineProperty(CitizenshipGenderInfoForm.prototype, "dataStore", {
        get: function () {
            return this.props.model.dataStore;
        },
        enumerable: true,
        configurable: true
    });
    CitizenshipGenderInfoForm.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    CitizenshipGenderInfoForm.prototype.onChange = function (id, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("Id", id);
                console.log("Value", value);
                this.json_data[id] = value;
                this.forceUpdate();
                return [2];
            });
        });
    };
    CitizenshipGenderInfoForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("CitizenshipGenderInfoForm validateApplication", this.isValid);
                return [2];
            });
        });
    };
    CitizenshipGenderInfoForm.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("CitizenshipGenderInfoForm validateApplication");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    CitizenshipGenderInfoForm.prototype.isValid = function () {
        console.log("Validate CitizenshipGenderInfoForm");
        var json_data = this.props.model.json_data;
        var specialRules = rules;
        var _a = findErrors_1.findErrors(this.json_data, specialRules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        console.log("Form errors", this.errors);
        return isValid;
    };
    CitizenshipGenderInfoForm.prototype.render = function () {
        var model = this.props.model;
        var json_data = model.json_data;
        return (React.createElement("div", null,
            React.createElement("section", { className: "section-content scw" },
                React.createElement("h2", { className: "section-title-spa" }, "Citizenship & Gender"),
                React.createElement("article", null,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-xs-12 col-md-12 space-bottom" },
                            React.createElement(Label_1.Label, { htmlFor: "citizenship", text: "Citizenship/Residence Status", hint: "(Select One)", required: true }),
                            React.createElement(Select_1.Select, { id: "citizenship", json_data: json_data, onChange: this.onChange, options: this.dataStore.citizenship, errors: this.errors })),
                        React.createElement("div", { className: "col-xs-12 col-md-12 space-bottom" },
                            React.createElement(Label_1.Label, { htmlFor: "gender", text: "Gender", hint: "(Select One)", required: true }),
                            React.createElement(Select_1.Select, { id: "gender", json_data: json_data, onChange: this.onChange, options: this.dataStore.gender, errors: this.errors })))))));
    };
    __decorate([
        mobx_1.observable
    ], CitizenshipGenderInfoForm.prototype, "errors", void 0);
    CitizenshipGenderInfoForm = __decorate([
        mobx_react_1.observer
    ], CitizenshipGenderInfoForm);
    return CitizenshipGenderInfoForm;
}(react_1.Component));
exports.CitizenshipGenderInfoForm = CitizenshipGenderInfoForm;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2l0aXplbnNoaXBHZW5kZXJJbmZvRm9ybS5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL0NpdGl6ZW5zaGlwR2VuZGVySW5mb0Zvcm0vQ2l0aXplbnNoaXBHZW5kZXJJbmZvRm9ybS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUU5QiwrQkFBK0I7QUFFL0IsMENBQXNDO0FBQ3RDLDRDQUF3QztBQUN4Qyx1REFBbUQ7QUFDbkQsNkJBQStCO0FBQy9CLHlDQUFtQztBQUVuQyx5REFBMEQ7QUFPMUQsSUFBTSxLQUFLLEdBQUc7SUFDVixXQUFXLEVBQUUsdUJBQVM7SUFDdEIsTUFBTSxFQUFFLHVCQUFTO0NBQ3BCLENBQUE7QUFHRDtJQUErQyw2Q0FBb0I7SUFNL0QsbUNBQVksS0FBSztRQUFqQixZQUNJLGtCQUFNLEtBQUssQ0FBQyxTQVFmO1FBWE8sWUFBTSxHQUE0QixFQUFFLENBQUE7UUFLeEMsS0FBSSxDQUFDLFFBQVEsR0FBRyxLQUFJLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxLQUFJLENBQUMsQ0FBQTtRQUN4QyxLQUFJLENBQUMsU0FBUyxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFBO1FBRXRDLEtBQUksQ0FBQyxPQUFPLEdBQUcsS0FBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSSxDQUFDLENBQUE7UUFDdEMsS0FBSSxDQUFDLE9BQU8sR0FBRyxLQUFJLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFJLENBQUMsQ0FBQTtRQUN0QyxLQUFLLENBQUMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxXQUFXLENBQUMsS0FBSSxDQUFDLE9BQU8sQ0FBQyxDQUFBOztJQUNwRCxDQUFDO0lBRUQsc0JBQVksZ0RBQVM7YUFBckI7WUFDSSxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQTtRQUNyQyxDQUFDOzs7T0FBQTtJQUVPLDJDQUFPLEdBQWY7UUFDSSxJQUFJLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQTtRQUMzQyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUE7SUFDdEIsQ0FBQztJQUVhLDRDQUFRLEdBQXRCLFVBQXVCLEVBQVUsRUFBRSxLQUFLOzs7Z0JBQ3BDLE9BQU8sQ0FBQyxHQUFHLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFBO2dCQUNyQixPQUFPLENBQUMsR0FBRyxDQUFDLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQTtnQkFDM0IsSUFBSSxDQUFDLFNBQVMsQ0FBQyxFQUFFLENBQUMsR0FBRyxLQUFLLENBQUE7Z0JBQzFCLElBQUksQ0FBQyxXQUFXLEVBQUUsQ0FBQTs7OztLQUNyQjtJQUVZLHFEQUFpQixHQUE5Qjs7O2dCQUNJLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxRQUFRLEVBQUUsQ0FBQTtnQkFDdEMsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsbUJBQW1CLENBQ2hDLCtDQUErQyxFQUMvQyxJQUFJLENBQUMsT0FBTyxDQUNmLENBQUE7Ozs7S0FDSjtJQUVZLHdEQUFvQixHQUFqQzs7O2dCQUNJLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLHNCQUFzQixDQUFDLCtDQUErQyxDQUFDLENBQUE7Z0JBQ3hGLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFBOzs7O0tBQzNEO0lBRU8sMkNBQU8sR0FBZjtRQUNJLE9BQU8sQ0FBQyxHQUFHLENBQUMsb0NBQW9DLENBQUMsQ0FBQTtRQUNqRCxJQUFNLFNBQVMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUE7UUFFNUMsSUFBSSxZQUFZLEdBQUcsS0FBSyxDQUFBO1FBRWxCLElBQUEsMERBQTRELEVBQTNELG9CQUFPLEVBQUUsa0JBQWtELENBQUE7UUFDbEUsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7UUFDcEIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxhQUFhLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQ3ZDLE9BQU8sT0FBTyxDQUFBO0lBQ2xCLENBQUM7SUFFTSwwQ0FBTSxHQUFiO1FBQ1csSUFBQSx3QkFBSyxDQUFjO1FBQ25CLElBQUEsMkJBQVMsQ0FBUztRQUN6QixPQUFPLENBQ0g7WUFDSSxpQ0FBUyxTQUFTLEVBQUMscUJBQXFCO2dCQUNwQyw0QkFBSSxTQUFTLEVBQUMsbUJBQW1CLDJCQUEwQjtnQkFDM0Q7b0JBQ0ksNkJBQUssU0FBUyxFQUFDLEtBQUs7d0JBQ2hCLDZCQUFLLFNBQVMsRUFBQyxrQ0FBa0M7NEJBQzdDLG9CQUFDLGFBQUssSUFDRixPQUFPLEVBQUMsYUFBYSxFQUNyQixJQUFJLEVBQUMsOEJBQThCLEVBQ25DLElBQUksRUFBQyxjQUFjLEVBQ25CLFFBQVEsU0FDVjs0QkFDRixvQkFBQyxlQUFNLElBQ0gsRUFBRSxFQUFDLGFBQWEsRUFDaEIsU0FBUyxFQUFFLFNBQVMsRUFDcEIsUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFRLEVBQ3ZCLE9BQU8sRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsRUFDbkMsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNLEdBQ3JCLENBQ0E7d0JBQ04sNkJBQUssU0FBUyxFQUFDLGtDQUFrQzs0QkFDN0Msb0JBQUMsYUFBSyxJQUNGLE9BQU8sRUFBQyxRQUFRLEVBQ2hCLElBQUksRUFBQyxRQUFRLEVBQ2IsSUFBSSxFQUFDLGNBQWMsRUFDbkIsUUFBUSxTQUNWOzRCQUNGLG9CQUFDLGVBQU0sSUFDSCxFQUFFLEVBQUMsUUFBUSxFQUNYLFNBQVMsRUFBRSxTQUFTLEVBQ3BCLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUSxFQUN2QixPQUFPLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQzlCLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxHQUNyQixDQUNBLENBQ0osQ0FDQSxDQUNKLENBQ1IsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQWxHRDtRQURDLGlCQUFVOzZEQUNpQztJQUpuQyx5QkFBeUI7UUFEckMscUJBQVE7T0FDSSx5QkFBeUIsQ0F1R3JDO0lBQUQsZ0NBQUM7Q0FBQSxBQXZHRCxDQUErQyxpQkFBUyxHQXVHdkQ7QUF2R1ksOERBQXlCIn0=